import { createContext } from "react";
import { IWithProjectItemContextProps } from "./IWithProjectItemContextProps";

export const ProjectItemContext = createContext<IWithProjectItemContextProps>({
  onSelectResult: null,
  projectId: null,
  projectItemId: null,
  selectedResultItemId: null,
  isOriginSelected: true,
  selectionMap: null,
  type: null
});
